var styles = {"badgeWrapper":"VBG__DS__badge-module__DEDWt","showBorder":"VBG__DS__badge-module__FUNwq","badgeContent":"VBG__DS__badge-module__cZW34","child":"VBG__DS__badge-module__CjdnL","tooltip":"VBG__DS__badge-module__X04nd","icon":"VBG__DS__badge-module__uO04b"};

export { styles as default };
